var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContact = function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    fill: "#5663FF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.824 22.384a20.302 20.302 0 0 1-6.263-.994 1.733 1.733 0 0 0-1.792.426l-2.785 3.495A26.937 26.937 0 0 1 7.76 13.194l3.46-2.946a1.812 1.812 0 0 0 .425-1.81 19.787 19.787 0 0 1-.993-6.262A1.774 1.774 0 0 0 8.895.419H2.756C1.798.42.646.845.646 2.176a30.43 30.43 0 0 0 30.178 30.179 1.861 1.861 0 0 0 1.757-2.094v-6.12a1.774 1.774 0 0 0-1.757-1.757Z"
  })));
};
export default SvgContact;